import script from "./ChFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./ChFeatures.vue?vue&type=script&setup=true&lang=js"

import "./ChFeatures.vue?vue&type=style&index=0&id=4acfe65f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acfe65f"]])

export default __exports__